import { useMemo } from "react";
import { useQuery } from "@apollo/client/react";

import { GetStageDocument } from "#app/lib/data";

export function useStageDetail(stageId: string) {
  const variables = useMemo(() => ({ id: stageId }), [stageId]);

  const { data, loading, error } = useQuery(GetStageDocument, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  const stage = data?.stage ?? null;

  return { stage, loading, error };
}
